import './search-widget.scss';

import { Application, Controller } from '@hotwired/stimulus';

const CSS_CLASS_FETCHED = 'fetched';
const CSS_CLASS_LOADING = 'loading';

const application = Application.start();
application.debug = process.env.NODE_ENV === 'development';
application.register(
    'terminal42--search-widget',
    class extends Controller {
        static targets = ['results', 'search', 'selection'];

        static values = {
            configToken: String,
            multiple: Boolean,
            name: String,
            url: String,
        };

        // Prevent the form submission when hitting the enter on keywords input search
        preventSubmit(event) {
            event.preventDefault();
        }

        search(event) {
            clearTimeout(this.debounce);

            this.debounce = setTimeout(() => {
                const input = event.target;

                if (input.value === '') {
                    this.searchTarget.classList.remove(CSS_CLASS_FETCHED);

                    return;
                }

                input.classList.add(CSS_CLASS_LOADING);

                this.#fetchRecords(input.value).finally(() => {
                    this.searchTarget.classList.add(CSS_CLASS_FETCHED);
                    input.classList.remove(CSS_CLASS_LOADING);
                });
            }, 300);
        }

        select(event) {
            const tbody = this.#getTable(this.selectionTarget, this.resultsTarget).querySelector('tbody');

            if (!this.multipleValue) {
                [...tbody.children].forEach((child) => this.resultsTarget.querySelector('tbody').prepend(child));
            }

            const row = event.currentTarget.closest('tr');

            tbody.appendChild(row);
            this.#toggleInput(row, false);
        }

        unselect(event) {
            const row = event.currentTarget.closest('tr');

            this.#getTable(this.resultsTarget, this.selectionTarget).prepend(row);
            this.#toggleInput(row, true);

            this.searchTarget.classList.add(CSS_CLASS_FETCHED);
        }

        #getTable(target, source) {
            let table = target.querySelector('table');

            if (table) {
                return table;
            }

            table = source.querySelector('table').cloneNode(true);
            table.querySelector('tbody').innerHTML = '';

            return target.appendChild(table);
        }

        #toggleInput(row, disabled) {
            row.querySelector('input[type="hidden"]').disabled = disabled;
        }

        async #fetchRecords(keywords) {
            let html = '';

            const payload = new FormData();
            payload.set('configToken', this.configTokenValue);
            payload.set('keywords', keywords);

            // Add it this way, so multiple values are also supported out of the box
            this.selectionTarget
                .querySelectorAll('input[type="hidden"]')
                .forEach((input) => payload.append(input.name, input.value));

            try {
                const response = await fetch(this.urlValue, {
                    body: payload,
                    method: 'POST',
                    headers: {
                        'Accept': 'text/html',
                        'X-Requested-With': 'XMLHttpRequest',
                    }
                });
                html = await response.text();
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(`Search widget error: ${error}`);
            }

            this.resultsTarget.innerHTML = html;
        }
    },
);
